import { useContext } from "react";
import { NavLink } from "react-router-dom";

import useAxios from "../../services/useAxios";

import UseFullDataContext from "../../context/UseFullData";

import { BsPrinter } from "react-icons/bs";

import ColorSchema from "../kits/Color";
import { EditIcon1, TickIcon, TrashIcon } from "../kits/Icons";
import { ReactSelect } from "../kits/Inputs/Inputs";

import { TimeStampToJalali } from "../../utils/helperFunction";
import ToastCustomize from "../kits/ToastCustomize";

export default function OrderItem({
  itemsData,
  statusList,
  setOrderListUpdater,
}) {
  const { factorToPrintFunc } = useContext(UseFullDataContext);
  const { execute: changeStatusApi } = useAxios("/order/change_order_status");
  const returnCustomerName = () => {
    let customerDataTemp = "";
    if (itemsData?.customer[0]?.corporate == 1) {
      customerDataTemp = `${itemsData?.customer[0]?.company_name}`;
      if (itemsData?.customer[0]?.main_user?.length > 0) {
        customerDataTemp += `(${itemsData?.main_user[0]?.mobile})`;
      } else {
        customerDataTemp += `(${itemsData?.customer[0]?.mobile})`;
      }
    } else {
      customerDataTemp = `${itemsData?.customer[0]?.firstname} ${itemsData?.customer[0]?.lastname}`;
      if (itemsData?.customer[0]?.main_user?.length > 0) {
        customerDataTemp += `(${itemsData?.customer[0]?.main_user[0]?.mobile})`;
      }
    }
    return customerDataTemp != "" ? customerDataTemp : "----";
  };
  const changeStatusFunc = (name, status, order_id) => {
    changeStatusApi({
      name: name,
      status: status,
      order_id: order_id,
    }).then((res) => {
      if (res.status == 1) {
        setOrderListUpdater((prev) => !prev);
        if (res.msg != undefined && res?.msg != "" && res?.msg != null) {
          ToastCustomize({
            // mainText: "تغییر وضعیت با موفقیت انجام شد.",
            mainText: res.msg,
            duration: 3000,
            toastType: "success",
            color: "success",
            position: "top-center",
            hasHeader: false,
          });
        }
      } else {
        if (res.msg != undefined && res?.msg != "" && res?.msg != null) {
          ToastCustomize({
            // mainText: "تغییر وضعیت با موفقیت انجام شد.",
            mainText: res.msg,
            duration: 3000,
            toastType: "success",
            color: "success",
            position: "top-center",
            hasHeader: false,
          });
        }
      }
    });
  };
  return (
    <div className={`order-item d-flex flex-wrap my-2 `}>
      <div className={`flex-grow-1 my-1 p-2 count `}>
        <h6 className="title-header">شناسه سفارش</h6>

        <p className="text-center pt-2 mt-3 ">{itemsData?.new_orders__id} </p>
      </div>
      <div className={`flex-grow-1 my-1 p-2 count `}>
        <h6 className="title-header">نوع سفارش</h6>

        <p className="text-center pt-2 mt-3 ">
          {itemsData?.type == 2 ? "فروش" : "خرید"}{" "}
        </p>
      </div>
      <div className={`flex-grow-1 my-1 p-2 title-long `}>
        <h6 className="title-header">مشتری</h6>

        <p className="text-center pt-2 mt-3 ">{returnCustomerName()}</p>
      </div>
      <div className={`flex-grow-1 my-1 p-2 count `}>
        <h6 className="title-header">تاریخ ثبت</h6>
        <p className="text-center pt-2 mt-3 ">
          {TimeStampToJalali(parseInt(itemsData?.mtm) * 1000, "YYYY/MM/DD")}
        </p>
      </div>
      <div className={`flex-grow-1 my-1 p-2 count `}>
        <h6 className="title-header">تاریخ سفارش</h6>
        <p className="text-center pt-2 mt-3 ">
          {itemsData?.order_date != "" &&
          itemsData?.order_date != undefined &&
          itemsData?.order_date != null &&
          itemsData?.order_date != 0
            ? TimeStampToJalali(
                parseInt(itemsData?.order_date) * 1000,
                "YYYY/MM/DD"
              )
            : "---"}
        </p>
      </div>
      <div className={`flex-grow-1 my-1 p-2 title `}>
        <h6 className="title-header">کاربر ثبت کننده</h6>

        <p className="text-center pt-2 mt-3 ">
          {itemsData?.made_user[0]?.fname == "" &&
          itemsData?.made_user[0]?.lname == ""
            ? itemsData?.made_user[0]?.mobile ?? "---"
            : `${itemsData?.made_user[0]?.fname ?? "--"} ${
                itemsData?.made_user[0]?.lname ?? "--"
              }`}
        </p>
      </div>
      <div className={`flex-grow-1 my-1 p-2 title `}>
        <h6 className="title-header">وضعیت پرداخت </h6>

        <p className="text-center pt-2 mt-3 "> {"---"}</p>
      </div>
      <div className="w-100 d-flex flex-wrap mt-2">
        <div className={`flex-grow-1 my-1 p-2 col-6 col-sm-3`}>
          <h6 className="title-header">وضعیت تولید </h6>

          <p className="text-center  "></p>
          <ReactSelect
            itemsList={statusList?.production}
            inputValue={statusList?.production.filter(
              (v) => v.value == itemsData?.production_status
            )}
            onChangeFunc={(e) => {
              changeStatusFunc("production", e?.value, itemsData?.id);
            }}
          />
        </div>
        <div className={`flex-grow-1 my-1 p-2 col-6 col-sm-3`}>
          <h6 className="title-header">وضعیت مالی </h6>

          <p className="text-center  "></p>
          <ReactSelect
            itemsList={statusList?.financial}
            inputValue={statusList?.financial.filter(
              (v) => v.value == itemsData?.financial_status
            )}
            onChangeFunc={(e) => {
              changeStatusFunc("financial", e?.value, itemsData?.id);
            }}
          />
        </div>
        <div className={`flex-grow-1 my-1 p-2 col-6 col-sm-3`}>
          <h6 className="title-header">وضعیت انبار </h6>

          <p className="text-center  "></p>
          <ReactSelect
            itemsList={statusList?.store}
            inputValue={statusList?.store.filter(
              (v) => v.value == itemsData?.repository_status
            )}
            onChangeFunc={(e) => {
              changeStatusFunc("repository", e?.value, itemsData?.id);
            }}
          />
        </div>
        <div className={`flex-grow-1 my-1 p-2 col-6 col-sm-3`}>
          <h6 className="title-header">وضعیت سفارش </h6>

          <p className="text-center  "></p>
          <ReactSelect
            itemsList={statusList?.detail_order}
            inputValue={statusList?.detail_order.filter(
              (v) => v.value == itemsData?.order_details_status
            )}
            onChangeFunc={(e) => {
              changeStatusFunc("order_details", e?.value, itemsData?.id);
            }}
          />
        </div>
      </div>

      <div
        className={`px-2 pt-3 pb-1 w-100 d-flex align-items-center property `}
      >
        <h6 className="align-self-start" style={{ width: 100 }}>
          اقلام سفارش
        </h6>

        <p className="ps-4 flex-grow-1" style={{ width: "85%" }}>
          {itemsData?.order_items?.map((value, index) => {
            let propertyTemp =
              JSON.parse(
                value?.json == "" ||
                  value?.json == undefined ||
                  value?.json == null
                  ? "[{}]"
                  : value?.json
              ) ?? [];
            propertyTemp = propertyTemp?.map(
              (v) =>
                `${v?.title} : ${
                  v?.type == 2 ? v?.input_value?.label : v?.input_value
                }`
            );
            propertyTemp = propertyTemp.join();
            return `${value?.product[0]?.title ?? ""}  ${propertyTemp} (${
              value?.count
            } عدد) ${index < itemsData?.order_items?.length - 1 ? "," : ""}`;
          })}
        </p>
      </div>
      <div className="w-100 d-flex justify-content-end m-1">
        <NavLink
          to={`/new-order/edit/${itemsData?.type}/${itemsData?.new_orders__id}`}
        >
          <EditIcon1
            color={ColorSchema.navy_custom}
            containerIconClassName="cursor-pointer me-1"
            style={{ width: 20, height: 20 }}
          />
        </NavLink>

        {/* <button */}
        <NavLink
          to={`/order-factor/${itemsData?.new_orders__id}`}
          className="text-decoration-none"
          // onClick={() => {
          //   factorToPrintFunc(itemsData);
          // }}
        >
          <BsPrinter
            color={ColorSchema.success_custom}
            style={{ width: 20, height: 20 }}
          />
        </NavLink>
        {/* </button> */}
      </div>
    </div>
  );
}
